import type { SelectHTMLAttributes } from 'react'
import { Trans } from '@lingui/macro'
import { useLocalizedCountryList } from '@jotta/i18n'
import clsx from 'clsx'
import { PlainBrandIcon } from '../../Icons/BrandIcon/BrandIcon'
import SvgBoldCaretDown from '@jotta/ui/SvgBoldCaretDown'

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>

export const Select = ({ className, ...rest }: SelectProps) => {
  return (
    <div className="relative">
      <select
        className={clsx(
          'input w-full py-2 pl-4 leading-normal',
          className,
          'appearance-none',
        )}
        {...rest}
      />
      <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 transform">
        <PlainBrandIcon icon={SvgBoldCaretDown} height={16} />
      </span>
    </div>
  )
}

export interface SelectCountryProps extends SelectProps {
  country?: string
  setCountry: (country: string) => void
}
export const SelectCountry = ({
  country,
  setCountry,
  ...rest
}: SelectCountryProps) => {
  const { countries } = useLocalizedCountryList()
  return (
    <Select
      value={country}
      onChange={e => setCountry(e.target.value)}
      {...rest}
    >
      {countries.map(({ code, key }) => (
        <option value={code.toLowerCase()} key={key}>
          <Trans id={key} />
        </option>
      ))}
    </Select>
  )
}
